import { productBriefToPrompt } from "../utils/productBriefToPrompt";
import type { ProductBrief } from "../types/productBrief";

export interface ProjectTranslation {
  bullets: string[];
  title?: string;
  description?: string;
  keywords?: string[];
  lastUpdated?: string;
}

export interface ProjectLike {
  name?: string;
  brand?: string;
  customDescription?: string;
  productBrief?: ProductBrief;
  masterLanguage?: string;
  hasLocalizationEnabled?: boolean;
  translations?: Record<string, ProjectTranslation>;
  data?: {
    title?: string;
    brand?: string;
    description?: string;
    keywords_list?: string[];
    feature_bullets?: string[];
  };
  context?: {
    title?: string;
    brand?: string;
    description?: string;
    keywords?: string[];
    bulletPoints?: string[];
    productBrief?: ProductBrief;
  };
}

export function pickContextFields(project: ProjectLike) {
  const title = project?.context?.title ?? project?.data?.title ?? project?.name ?? "";
  const brand = project?.context?.brand ?? project?.brand ?? project?.data?.brand ?? "";
  const productBrief = project?.productBrief ?? project?.context?.productBrief;
  const description =
    project?.context?.description ??
    project?.customDescription ??
    (productBrief ? productBriefToPrompt(productBrief) : null) ??
    project?.data?.description ??
    "";
  const keywords = project?.context?.keywords ?? project?.data?.keywords_list ?? [];
  const bulletPoints = project?.context?.bulletPoints ?? project?.data?.feature_bullets ?? [];
  return { title, brand, description, keywords, bulletPoints, productBrief };
}

export async function updateProjectContext(params: {
  projectId: string | undefined;
  userId?: string | undefined;
  updates: Partial<ProjectLike["context"]>;
}) {
  const { projectId, userId, updates } = params;
  if (!projectId) return;
  await fetch("/.netlify/functions/updateProjectContext", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ projectId, userId, updates }),
  });
}


